import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
 
// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
 
// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/FMPFooter";
 
// Templar page sections
import Header from "pages/Produtos/Templar/Sections/Header";
import Video from "pages/Produtos/Templar/Sections/Video";
import SobreDCTemplar from "pages/Produtos/Templar/Sections/DCTemplar";
import Faq from "pages/Produtos/Templar/Sections/Faq";
 
 
// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
 
// Images
import ContactUsOne from "pages/Produtos/Templar/Components/ContactUsOne";
 
function Templar() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "pages/Ajuda/ContateNos",
          label: "Contate-nos",
          color: "info",
        }}
        sticky
      />
      <Header />
      <MKBox p={3}>
        <Video />
        <SobreDCTemplar />
        <Faq />
        {
        //<ContactUsOne/>
        }
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}
 
export default Templar;
